import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from './contexts/AuthContext';
import theme from './theme';
import CookiesBanner from './components/common/CookiesBanner';
import analyticsManager from './utils/analytics';

// Tous les composants importés directement - plus de lazy loading
import HomePage from './components/HomePage';
import ResponsiveSalonProfile from './components/ResponsiveSalonProfile';
import PricingPage from './components/PricingPage';
import About from './components/pages/About';
import Features from './components/pages/Features';
import Support from './components/pages/Support';
import Posts from './components/pages/Posts';
import PoseOnglesGel from './components/pages/PoseOnglesGel';
import ProsthesisteOngulaire from './components/pages/ProsthesisteOngulaire';
import NotFound from './components/pages/NotFound';
import PrivacyPolicy from './components/legal/PrivacyPolicy';
import TermsOfService from './components/legal/TermsOfService';
import CookiePolicy from './components/legal/CookiePolicy';
import Dashboard from './components/Dashboard';
import ClientDashboard from './components/ClientDashboard';
import DashboardRedirect from './components/DashboardRedirect';
import Auth from './components/Auth';
import AdminDashboard from './components/AdminDashboard';
import ProtectedRoute from './components/ProtectedRoute';
import BookingConfirmation from './components/BookingConfirmation';

function App() {
  const handleCookieConsent = (preferences) => {
    analyticsManager.setAnalyticsEnabled(preferences.analytics);
    analyticsManager.trackCookieConsent(preferences.analytics);
  };

  return (
    <HelmetProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <AuthProvider>
          <Router>
            <div className="App">
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/pricing" element={<PricingPage />} />
                <Route path="/salon/:salonId" element={<ResponsiveSalonProfile />} />
                
                <Route path="/posts" element={<Posts />} />
                <Route path="/posts/:slug" element={<Posts />} />
                <Route path="/posts/pose-ongles-gel" element={<PoseOnglesGel />} />
                <Route path="/posts/prothesiste-ongulaire" element={<ProsthesisteOngulaire />} />
                
                <Route path="/privacy" element={<PrivacyPolicy />} />
                <Route path="/terms" element={<TermsOfService />} />
                <Route path="/cookies" element={<CookiePolicy />} />
                
                <Route path="/about" element={<About />} />
                <Route path="/features" element={<Features />} />
                <Route path="/support" element={<Support />} />
                
                <Route path="/auth" element={<Auth />} />
                <Route path="/booking-confirmation" element={<BookingConfirmation />} />
                <Route path="/my-dashboard" element={<DashboardRedirect />} />
                
                <Route
                  path="/dashboard"
                  element={
                    <ProtectedRoute>
                      <Dashboard />
                    </ProtectedRoute>
                  }
                />
                
                <Route
                  path="/client-dashboard"
                  element={
                    <ProtectedRoute clientOnly>
                      <ClientDashboard />
                    </ProtectedRoute>
                  }
                />
                
                <Route
                  path="/admin"
                  element={
                    <ProtectedRoute adminOnly>
                      <AdminDashboard />
                    </ProtectedRoute>
                  }
                />
                
                <Route path="*" element={<NotFound />} />
              </Routes>
              
              <CookiesBanner onAccept={handleCookieConsent} />
            </div>
          </Router>
        </AuthProvider>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
